export default __webpack_public_path__ + "static/media/pdf.b587d4c0.svg";